import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold mb-4" }, " Formulario de registro ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex bg-green-200 p-4 rounded-md" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold" }, " En esta ventana podrás gestionar las preguntas que modificarán el flujo de instrucciones en la plataforma. En el debe seleccionar el tipo de pregunta que desea guardar en el registro. ")
], -1)
const _hoisted_3 = { class: "font-bold mb-4 mt-5" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "self-end w-full flex justify-end my-7 items-center" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { style: {"text-align":"left"} }
const _hoisted_8 = { class: "p-4 border bg-success/30 border-gray-200 rounded-md w-2/6" }
const _hoisted_9 = { class: "flex justify-between items-center" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = ["name"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = ["name"]
const _hoisted_15 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selector = _resolveComponent("Selector")!
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!
  const _component_FormHandleRegister = _resolveComponent("FormHandleRegister")!
  const _component_ComponentCard = _resolveComponent("ComponentCard")!

  return (_openBlock(), _createBlock(_component_ComponentCard, { class: "flex w-full p-7 mt-10" }, {
    header: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.showEditFormModal), 1),
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2,
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.formTitle), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Selector, {
          class: "w-3/4 mr-6",
          selectedItem: _ctx.tipoSelector,
          items: _ctx.formSelector,
          onUpdate: _ctx.onUpdateSelector
        }, null, 8, ["selectedItem", "items", "onUpdate"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_AddButton, {
            class: "mt-5",
            section: 'form-register',
            action: 'create',
            onReloadForm: _ctx.reaload
          }, null, 8, ["onReloadForm"])
        ])
      ]),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: question.id
            }, [
              _createElementVNode("td", _hoisted_7, _toDisplayString(question.content), 1),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (question.answerTypeFront == 'RADIAL')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("input", {
                            id: "bordered-radio-1",
                            disabled: "",
                            type: "radio",
                            value: "",
                            name: 'bordered-radio-' + question.id,
                            class: "w-4 h-4 text-success bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-success dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          }, null, 8, _hoisted_11),
                          _createElementVNode("label", {
                            for: 'bordered-radio-1-' + question.id,
                            class: "ml-2 text-sm font-medium text-success"
                          }, "Si", 8, _hoisted_12)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("input", {
                            id: "bordered-radio-2",
                            disabled: "",
                            type: "radio",
                            value: "",
                            name: 'bordered-radio-' + question.id,
                            class: "w-4 h-4 text-success bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-success dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          }, null, 8, _hoisted_14),
                          _createElementVNode("label", {
                            for: 'bordered-radio-2-' + question.id,
                            class: "ml-2 text-sm font-medium text-success"
                          }, "No", 8, _hoisted_15)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (question.answerTypeFront == 'SELECTOR')
                    ? (_openBlock(), _createBlock(_component_Selector, {
                        key: 1,
                        itsDisabled: true,
                        class: "w-1/3 mr-6"
                      }))
                    : _createCommentVNode("", true),
                  (question.answerTypeFront == 'INPUT')
                    ? (_openBlock(), _createBlock(_component_TextField, {
                        key: 2,
                        class: "w-1/3 mr-6",
                        placeholder: 'Escribir Tipo',
                        type: "numeric",
                        saveOnFocus: true,
                        onDateSuccess: ($event: any) => (_ctx.determineAnwerType(question)),
                        model: question.responseForm,
                        "onUpdate:model": ($event: any) => ((question.responseForm) = $event),
                        name: 'text' + question.id
                      }, null, 8, ["onDateSuccess", "model", "onUpdate:model", "name"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_mdicon, {
                    name: "pencil",
                    class: "cursor-pointer px-2 py-2 rounded-md bg-warning text-white hover:bg-yellow-400 focus:bg-yellow-400",
                    onClick: ($event: any) => (_ctx.editForm(question.id ?? 0))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_mdicon, {
                    name: "delete",
                    class: "cursor-pointer px-2 py-2 rounded-md bg-red-600 text-white hover:bg-red-500 focus:bg-red-500",
                    onClick: ($event: any) => (_ctx.showDeleteModal(question.id ?? 0))
                  }, null, 8, ["onClick"])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.showAlert)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              type: 'success',
              message: _ctx.message
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_ModalAlert, {
        title: _ctx.title,
        message: _ctx.message,
        visible: _ctx.showModal,
        option: false,
        onAccept: _ctx.handleAccept,
        onDeleteItem: _ctx.handleDelete,
        onCancelAlert: _ctx.handleCancel
      }, null, 8, ["title", "message", "visible", "onAccept", "onDeleteItem", "onCancelAlert"]),
      (_ctx.showEditFormModal)
        ? (_openBlock(), _createBlock(_component_FormHandleRegister, {
            key: 0,
            action: 'update',
            onCloseAction: _ctx.reaload,
            itemId: _ctx.questionId,
            visible: _ctx.showEditFormModal
          }, null, 8, ["onCloseAction", "itemId", "visible"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}